import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=09916ca9&"
import script from "./Buscador.vue?vue&type=script&lang=ts&"
export * from "./Buscador.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports